import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { useUserValue, useActions } from '../features/login';

import MasterPage from './PortalControl';


export default function Routes(props) {
  
  
    return (       
            <Switch>
            <Route path='/' exact render={() => <MasterPage link="HomePage"/>} />                      
            </Switch>
    );

}

